import { ImageModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";

export class ImageRepo extends BaseDataRepository<ImageModel> {
  protected baseUrl = 'image';
}

export default ImageRepo;
